module.exports = __webpack_public_path__ + "static/media/5S.8f300fb5.svg";